import { Col, Collapse, Row } from 'antd';
import React from 'react';

import { AmenitiesCard } from '../../../components/AmenitiesCard';
import { hotel_facts } from '../../../common/facts';

const facts = hotel_facts.en;

export const HotelAmenities = ({ data, amenitiesRef }) => {

    if (!data.facts) return null;
    const { Panel } = Collapse;

    return (
        <div
            id='hotel-amenities-container'
            ref={amenitiesRef}
            className='mb-5'
        >
            <div
                id='hotel-amenities'
                className='p-4'
            >
                <h3>More Amenities</h3>
                <Collapse
                    bordered={false}
                    defaultActiveKey={[]}
                    accordion={true}
                >
                    {
                        Object.keys(facts.contextTree)
                            .filter(c => !facts.contextTree[c].invisible && (
                                (
                                    facts.contextTree[c].sub ?
                                        Object.keys(facts.contextTree[c].sub).some(s => facts.contextTree[c].sub[s].facts.some(f => data.facts[`${f}`]))
                                        :
                                        false
                                )
                                ||
                                facts.contextTree[c].facts.some(e => data.facts[`${e}`])
                            ))
                            .sort((a, b) => facts.contextTree[a].order - facts.contextTree[b].order)
                            .map((c, i) => (
                                <Panel key={`${i}`}
                                    header={facts.contextTree[c].label}
                                >
                                    <div>
                                        {
                                            facts.contextTree[c].sub ?
                                                Object.keys(facts.contextTree[c].sub)
                                                    .filter(s => facts.contextTree[c].sub[s].facts.some(f => data.facts[`${f}`]))
                                                    .map(s => (
                                                        <React.Fragment key={`${c}-${s}`}>
                                                            <p className='fw-bold'>{facts.contextTree[c].sub[s].label}</p>
                                                            <Row gutter={[16, 16]} className='mb-4 mt-2'>
                                                                {
                                                                    facts.contextTree[c].sub[s].facts
                                                                        .filter(f => data.facts[`${f}`])
                                                                        .map(f => (
                                                                            <Col xs={12} md={6} key={`${c}-${s}-${f}`}>
                                                                                <AmenitiesCard fact={`${f}`} factValue={data.facts[`${f}`]} />
                                                                            </Col>
                                                                        ))
                                                                }
                                                            </Row>
                                                        </React.Fragment>
                                                    ))
                                                :
                                                null
                                        }
                                        <Row gutter={[16, 16]} className='mt-2'>
                                            {
                                                facts.contextTree[c].facts
                                                    .filter(f => data.facts[`${f}`])
                                                    .map(f => (
                                                        <Col
                                                            xs={6} md={4} lg={3} xl={2}
                                                            key={`${c}-${f}`}
                                                        >
                                                            <AmenitiesCard fact={`${f}`} factValue={data.facts[`${f}`]} />
                                                        </Col>
                                                    ))
                                            }
                                        </Row>

                                    </div>
                                </Panel>
                            ))
                    }
                </Collapse>
            </div>
        </div>

    )
}
